import { MainLayout } from '../layouts'
import projectManagement from '@/assets/icons/sidebar/projectManagement.svg'
import assetManagement from '@/assets/icons/sidebar/assetManagement.svg'
import periodicMaintance from '@/assets/icons/sidebar/periodicMaintance.svg'
import taskManagement from '@/assets/icons/sidebar/taskManagement.svg'
import report from '@/assets/icons/sidebar/report.svg'
import arisingRepair from '@/assets/icons/sidebar/arisingRepair.svg'

import { RouterName, UriRole } from '@/routes/config.ts'
export const routes = [
  {
    path: '/',
    name: RouterName.HOME,
    component: MainLayout,
    redirect: '/welcome',
    hidden: false,
    meta: {
      title: 'Trang chủ',
      page: 'home'
    },
    children: [
      {
        hidden: true,
        path: '/welcome',
        name: RouterName.WELCOME,
        component: () => import('@/views/Welcome.vue'),
        meta: {
          page: 'welcome'
        }
      },
      // {
      //   path: '/project-management',
      //   name: RouterName.PROJECT_MANAGEMENT,
      //   component: () => import('@/views/project-management/index.vue'),
      //   meta: {
      //     title: 'Quản lý dự án',
      //     icon: projectManagement,
      //     page: 'project-management'
      //   },
      //   hidden: false,
      //   children: [
      //     {
      //       path: '/project-management/project-list',
      //       name: RouterName.PROJECT_LIST,
      //       component: () => import('@/views/project-management/project-list/index.vue'),
      //       meta: {
      //         title: 'Danh sách dự án'
      //         // uriRole: UriRole.PROJECT_LIST
      //       }
      //     },
      //     {
      //       path: '/project-management/project-list/:id',
      //       name: RouterName.PROJECT_DETAIL,
      //       component: () =>
      //         import('@/views/project-management/project-list/project-detail/index.vue'),
      //       meta: {
      //         title: 'Chi tiết dự án'
      //         // uriRole: UriRole.PROJECT_DETAIL
      //       }
      //     }
      //   ]
      // },
      {
        path: '/asset-management',
        name: RouterName.ASSET_MANAGEMENT,
        component: () => import('@/views/asset-management/index.vue'),
        meta: {
          title: 'Quản lý tài sản',
          icon: assetManagement,
          page: 'asset-management'
        },
        hidden: false,
        children: [
          {
            path: '/asset-management/asset-hier',
            name: RouterName.ASSET_HIER_TREE,
            component: () => import('@/views/asset-management/asset-hier-tree/index.vue'),
            meta: {
              title: 'Quản lý cây tài sản',
              uriRole: UriRole.ASSET_HIER_TREE
            }
          },
          {
            path: '/asset-management/asset-model',
            name: RouterName.ASSET_MODEL,
            component: () => import('@/views/asset-management/asset-model/index.vue'),
            meta: {
              title: 'Chủng loại tài sản'
              // uriRole: UriRole.ASSET_MODEL
            }
          },
          {
            path: '/asset-management/asset-model/detail',
            name: RouterName.ASSET_MODEL_DETAIL,
            component: () =>
              import('@/views/asset-management/asset-model/AssetModelDetailPage.vue'),
            meta: {
              title: 'Chi tiết chủng loại tài sản'
              // uriRole: UriRole.ASSET_MODEL
            }
          },
          {
            path: '/asset-management/asset-group',
            name: RouterName.ASSET_GROUP,
            component: () => import('@/views/asset-management/asset-group/index.vue'),
            meta: {
              title: 'Nhóm tài sản'
              // uriRole: UriRole.ASSET_GROUP
            }
          },
          {
            path: '/asset-management/asset',
            name: RouterName.ASSET,
            component: () => import('@/views/asset-management/asset/index.vue'),
            meta: {
              title: 'Quản lý thông tin tài sản'
            }
          },
          {
            path: '/asset-management/asset/detail',
            name: RouterName.ASSET_DETAIL,
            component: () => import('@/views/asset-management/asset/AssetDetailPage.vue'),
            meta: {
              title: 'Thông tin tài sản'
              // uriRole: UriRole.ASSET_MODEL
            }
          },
          {
            path: '/asset-management/inventory-item',
            name: RouterName.INVENTORY_ITEM,
            component: () => import('@/views/asset-management/inventory-item/index.vue'),
            meta: {
              title: 'Quản lý thông tin vật tư'
              // uriRole: UriRole.INVENTORY_ITEM
            }
          }
        ]
      },
      {
        path: '/periodic-maintenance',
        name: RouterName.PERIODIC_MAINTENANCE,
        component: () => import('@/views/periodic-mainten/index.vue'),
        meta: {
          title: 'Bảo dưỡng định kỳ',
          icon: periodicMaintance,
          page: 'periodic-maintenance'
        },
        hidden: false,
        children: [
          {
            path: '/periodic-maintenance/plan',
            name: RouterName.MAINTENANCE_PLAN,
            component: () => import('@/views/periodic-mainten/maintenance-plan/index.vue'),
            meta: {
              title: 'Kế hoạch bảo dưỡng'
              // uriRole: UriRole.MAINTENANCE_PLAN
            }
          }
        ]
      },
      {
        path: '/arising-repair',
        name: RouterName.ARISING_REPAIR,
        component: () => import('@/views/CommingSoon.vue'),
        meta: {
          title: 'Sửa chữa phát sinh',
          icon: arisingRepair,
          page: 'arising-repair'
        },
        hidden: false
      },
      {
        path: '/task-management',
        name: RouterName.TASK_MANAGEMENT,
        component: () => import('@/views/CommingSoon.vue'),
        meta: {
          title: 'Quản lý công việc',
          icon: taskManagement,
          page: 'task-management'
        },
        hidden: false
      },
      {
        path: '/report',
        name: RouterName.REPORT,
        component: () => import('@/views/CommingSoon.vue'),
        meta: {
          title: 'Báo cáo',
          icon: report,
          page: 'report'
        },
        hidden: false
      }
    ]
  },
  {
    path: '/login',
    name: RouterName.LOGIN,
    component: () => import('@/views/auth/Login.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: RouterName.NOT_FOUND,
    component: () => import('@/views/exception/404.vue')
  },
  {
    path: '/403',
    name: RouterName.NOT_HAVE_PERMISSION,
    component: () => import('@/views/exception/403.vue')
  }
]
